import { GetterTree } from 'vuex';
import { ClassRecord, ClassRecordsState } from '@/store/lessons/classRecord/types';
import { RootState } from '@/store/types';

const getters : GetterTree<ClassRecordsState, RootState> = {
  findClassRecordByLessonId: (state) => (lessonId: string): ClassRecord|null => {
    return state.classRecords.find((cr) => cr.lessonId === lessonId) || null
  },
};

export default getters;
